<template>
    <div style="display: none;">
        <div ref="win">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { type, deepCopy, Size, Pixel } from '../../utils/assist'
import Configurable from '../a-map/configurable'
import EventAgent from '../a-map/eventAgent'

// 覆盖物-标记
export default {
    name: "AMapInfoWindow",

    mixins: [Configurable, EventAgent],

    inject: {
        amap: { default: null }
    },

    props: {
        // 是否显示
        show: {
            type: Boolean,
            default: false,
        },
        // 是否自定义窗体。设为true时，信息窗体外框及内容完全按照content所设的值添加（默认为false，具有默认外窗）
        isCustom: {
            type: Boolean,
            default: false,
        },
        // 是否自动调整窗体到视野内
        autoMove: {
            type: Boolean,
            default: false,
        },
        // 控制是否在鼠标点击地图后关闭信息窗体，默认false，鼠标点击地图后不关闭信息窗体
        closeWhenClickMap: {
            type: Boolean,
            default: false,
        },
        // 信息窗体尺寸(width, height)
        size: {
            type: [Array, Object],
        },
        // 设置点标记锚点
        anchor: {
            type: String,
            default: 'bottom-center',
            validator(val) {
                return ["top-left", "top-center", "top-right", "middle-left", "center", "middle-right", "bottom-left", "bottom-center", "bottom-right"].indexOf(val) >= 0
            }
        },
        // 信息窗体显示位置偏移量(x, y)
        offset: {
            type: [Array, Object],
        },
        // 信息窗体显示基点位置
        position: {
            type: [Array, Object],
            validator(val) {
                // 若position有值，则必须为合法的经纬度组合
                if (type(val) == "array") {
                    var [lng, lat] = val

                    if (isNaN(lng) || isNaN(lat)) {
                        return false
                    }
                }

                return true
            }
        },
        // 是否显示信息窗体阴影
        showShadow: {
            type: Boolean,
            default: false,
        },
    },

    model: {
        prop: 'show',
        event: 'input',
    },

    data() {
        return {
            configExclude: ["value"],
            infoWindow: null,
            content: this.$slots.default,
        }
    },

    methods: {
        initInfoWindow() {
            if (AMap && AMap.InfoWindow) {
                this.infoWindow = new AMap.InfoWindow(Object.assign({}, this.config, {
                    content: this.$refs.win,
                    offset: Pixel(this.offset),
                    size: Size(this.size),
                }))

                // 事件监听
                this.infoWindow.on("close", () => this.$emit("input", false))
                this.startAgent(this.infoWindow)

                return this.infoWindow
            } else {
                return new Error("AMap.InfoWindow不存在")
            }
        },
        resolve() {
            return "infoWindow"
        },
        // 显示窗体
        open() {
            this.infoWindow.open(this.amap.map, this.position)
            this.$emit("input", true)
        },
        // 关闭窗体
        close() {
            this.infoWindow.close()
            this.$emit("input", false)
        },
        // 获取信息窗体是否打开
        getIsOpen() {
            return this.infoWindow.getIsOpen()
        },
        // 获取信息窗体内容 ，结果以字符串方式返回
        getContent() {
            return this.infoWindow.getContent()
        },
        // 获取信息窗体显示基点位置
        getPosition() {
            return this.infoWindow.getPosition()
        },
        // 获取信息窗体锚点
        getAnchor() {
            return this.infoWindow.getAnchor()
        },
        // 获取信息窗体大小
        getSize() {
            return this.infoWindow.getSize()
        },
    },

    watch: {
        show(val) {
            if (this.infoWindow) {
                val ? this.open() : this.close()
            }
        },
        content(val) {
            if (this.infoWindow) {
                this.$nextTick(() => {
                    this.infoWindow.setContent(this.$refs.win)
                })
            }
        },
        position(val) {
            if (this.infoWindow) {
                this.infoWindow.setPosition(val)
            }
        },
        anchor(val) {
            if (this.infoWindow) {
                this.infoWindow.setAnchor(val)
            }
        },
        size(val) {
            if (this.infoWindow && this.isCustom) {
                this.infoWindow.setSize(Size(val))
            }
        },
    },

    mounted() {
        this.$watch(function() {
            return this.amap.load
        }, function(load) {
            // map 创建完毕
            if (load) {
                // AMap的直接子级
                if (this.$parent.$options.name == "AMap") {
                    // 取消config bubble
                    this.configBubble = false

                    var infoWindow = this.initInfoWindow()

                    if (type(infoWindow) == "error") {
                        throw infoWindow
                    }

                    this.amap.overlay.push(infoWindow)
                } else {
                    return new Error("AMap.InfoWindow只能添加到AMap组件")
                }
            }
        }, {
            immediate: true
        })
    },

    beforeDestroy() {
        if (this.infoWindow) {
            // 从amap移除
            this.amap.overlay.splice(this.amap.overlay.indexOf(this.infoWindow), 1)
            // 事件解绑
            this.stopAgent(this.infoWindow)
        }
    }
}
</script>